import React from "react";
import { Search, Globe, Mic, Bot, Headphones, Share2, MapPin, CreditCard } from "lucide-react";

const items = [
  { icon: Search, label: "SEO / AEO" },
  { icon: Globe, label: "AI Websites" },
  { icon: Mic, label: "Voice Search" },
  { icon: MapPin, label: "Google Business" },
  { icon: Share2, label: "Social Media" },
  { icon: Bot, label: "AI Assistants" },
  { icon: Headphones, label: "IT Support" },
  { icon: CreditCard, label: "Digital Cards" },
];

export default function TrustBar() {
  const list = [...items, ...items];
  return (
    <section className="py-8 bg-slate-900 text-slate-300 border-y border-slate-800 overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 flex items-center gap-6">
        <div className="flex-shrink-0 text-xs uppercase tracking-widest text-cyan-400 font-bold">
          Capabilities
        </div>
        <div className="flex-1 overflow-hidden">
          <div className="marquee-track flex items-center gap-10 w-max">
            {list.map((it, idx) => {
              const Ic = it.icon;
              return (
                <div key={idx} className="flex items-center gap-2 whitespace-nowrap">
                  <Ic className="h-4 w-4 text-cyan-400" />
                  <span className="text-sm font-medium">{it.label}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
